import { getRecentProjectsFromLocalStorage } from "lib/actions/recentProjects/getRecentProjectsFromLocalStorage";
import { ProjectListModel } from "components/modules/Projects/lib/types/ProjectListModel";

export function filterProjectsByRecent(projects: ProjectListModel[]) {
  const recent = getRecentProjectsFromLocalStorage();
  const mapped = recent
    .map((recentProject) =>
      projects?.find((project) => project.id === recentProject.id),
    )
    .filter((project) => !!project);
  return mapped;
}
